<tr *ngFor="let service of services">
  <th>{{ service.name }}</th>
  <td>{{ service.price }} р.</td>
</tr>